export const rejectionsReports = {
  id: 'rejections',
  name: 'Rejections',
  description: '',
  visibility: 'private',
  subject_type: 'rejections',
  layout: {
    data: [
      {
        h: 7,
        w: 6,
        x: 0,
        y: 0,
        key: '4803',
        maxH: 13,
        maxW: 6,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 6,
        x: 6,
        y: 0,
        key: '4804',
        maxH: 13,
        maxW: 6,
        minH: 7,
        minW: 3,
      },
      {
        h: 21,
        w: 12,
        x: 0,
        y: 7,
        key: '4805',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 28,
        key: '4806',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 28,
        key: '4807',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 25,
        w: 8,
        x: 2,
        y: 51,
        key: '4808',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 76,
        key: '4809',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 76,
        key: '4810',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 19,
        w: 12,
        x: 0,
        y: 99,
        key: '4811',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4803,
      subject_type: 'rejections',
      metadata: {
        id: 'rejections_rejected_candidate',
        tileKey: 'rejections_rejected_candidate',
        apiParam: 'card',
        headerKey: 'rejections',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4804,
      subject_type: 'rejections',
      metadata: {
        id: 'rejections_time_to_reject',
        unit: 'time',
        tileKey: 'rejections_time_to_reject',
        apiParam: 'card',
        // headerKey: 'time_to_reject',
        componentType: 'card',
        calculationType: 'avgChange',
        metricKeys: {
          numerator: 'time_to_reject',
          denominator: 'rejections',
        },
      },
      query: null,
    },
    {
      id: 4805,
      subject_type: 'rejections',
      metadata: {
        id: 'rejections_trend_chart',
        tileKey: 'rejections_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4806,
      subject_type: 'rejections',
      metadata: {
        id: 'we_rejected_them',
        tileKey: 'we_rejected_them',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'rejection_type',
          group_by_2: 'rejection_reason',
        },
      },
      query: null,
    },
    {
      id: 4807,
      subject_type: 'rejections',
      metadata: {
        id: 'they_rejected_us',
        tileKey: 'they_rejected_us',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'rejection_type',
          group_by_2: 'rejection_reason',
        },
      },
      query: null,
    },
    {
      id: 4808,
      subject_type: 'rejections',
      metadata: {
        id: 'others',
        tileKey: 'others',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'rejection_type',
          group_by_2: 'rejection_reason',
        },
      },
      query: null,
    },
    {
      id: 4809,
      subject_type: 'rejections',
      metadata: {
        id: 'rejection_by_stage',
        tileKey: 'rejection_by_stage',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'rejected_milestone',
        },
      },
      query: null,
    },
    {
      id: 4810,
      subject_type: 'rejections',
      metadata: {
        id: 'rejection_by_source',
        tileKey: 'rejection_by_source',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'appl_contact_source',
        },
      },
      query: null,
    },
    {
      id: 4811,
      subject_type: 'rejections',
      metadata: {
        id: 'rejections_table',
        tileKey: 'rejections_table',
        apiParam: 'chart_table',
        headerKeys: [
          'rejections_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
